import { render, staticRenderFns } from "./region-heat-map.vue?vue&type=template&id=37f6322a&scoped=true"
import script from "./region-heat-map.vue?vue&type=script&lang=js"
export * from "./region-heat-map.vue?vue&type=script&lang=js"
import style0 from "./region-heat-map.vue?vue&type=style&index=0&id=37f6322a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f6322a",
  null
  
)

export default component.exports